import React, { useEffect } from 'react'
import { Col, Row } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';

import TimbradoRetencionList from './list/TimbradoRetencionList';
import TimbradoRetencionSearch from './list/components/TimbradoRetencionSearch';

const TimbradoRetenciones = (props) => {

  useEffect(() => {
    window.setAppTitle('Retenciones');
  }, [])

  const handleOnRowClick = (data) => {
    props.history.replace({
      pathname: `/developers/timbrado/retenciones/${data.id}`,
      state: {
        data: {...data}
      }
    });
  }

  return (
    <div>
      { Guardian.allows('developer.request.retenciones') && (
        <>
          <Row>

            <Col sm="auto" md="9" className="mb-2">
              <TimbradoRetencionSearch />
            </Col>

          </Row>

          <TimbradoRetencionList onRowClick={ handleOnRowClick }/>
        </>
      )}
    </div>
  )
}

export default TimbradoRetenciones;